<template>
  <div :key="renderKey">
    <formulate-input
      ref="input"
      :disabled="disabled"
      v-if="field.type !== 'group' && field.type !== 'file' && !field.render_params.hide"
      :key="field.type"
      :class="{'disabled': disabled}"
      v-bind="[field, extraBinds, $props, (field.render_params || {})]">
      <template #label="{label}">
        <label>
          <div v-html-safe="label"/>
        </label>
      </template>
    </formulate-input>
    <formulate-input
      ref="input"
      :disabled="disabled"
      v-else-if="field.type !== 'group' && field.type === 'file' && !field.off && !field.render_params.hide"
      :key="field.type"
      :class="{'disabled': disabled}"
      v-bind="[field, extraBinds, $props, (field.render_params || {})]"
      :value="field.render_params.value">
      <template v-if="field.type === 'file'" #prefix>
        <div
          style="text-shadow: 1px 1px 3px grey;"
          class="file-placeholder">
          Anexar documento
        </div>
      </template>
      <template #label="{label}">
        <label>
          <div v-html-safe="label"/>
        </label>
      </template>
    </formulate-input>
  </div>
</template>

<script>
export default {
  data: () => ({
    renderKey: 0,
    minHeightTextArea: 45
  }),
  props: {
    field: {
      default: () => ({}),
      type: Object
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    clear() {
      const inputVm = this.$refs.input
      if (inputVm && inputVm.context && inputVm.applyDefaultValue) {
        inputVm.context.model = null
        inputVm.applyDefaultValue()
      }
    },
    resizeTextArea () {
      //TODO melhorar
      let _self = this.$refs.input.$el.getElementsByTagName('textarea')
      /*
      const inputs = [...(document.querySelectorAll('textarea'))]
      if (inputs.length > 0) {
        inputs.forEach((input) => {
          //console.log(input.scrollHeight)
        })
      }
    */
      const important = 'important'
      this.$nextTick(() => {
        let contentHeight = _self[0].scrollHeight+1//this.$el.scrollHeight + 1
        //console.log('contentHeight:'+contentHeight)
        if (this.minHeightTextArea) {
          contentHeight = contentHeight < this.minHeightTextArea ? this.minHeightTextArea : contentHeight
        }
        if (this.maxHeight) {
          if (contentHeight > this.maxHeight) {
            contentHeight = this.maxHeight
            this.maxHeightScroll = true
          } else {
            this.maxHeightScroll = false
          }
        }
        let heightVal = contentHeight + 'px'
        heightVal = `${heightVal}${important ? ' !important' : ''}`
        let styleTextArea = 'overflow: hidden; resize: none !important;'
        _self[0].style.cssText = styleTextArea+' height: '+heightVal
      })
    }
  },
  computed: {
    extraBinds() {
      if (this.field.type === 'file') {
        return {
          'add-label': 'Adicionar Arquivo',
          'multiple': true,
          'validation': 'mime:application/pdf',

        }
      } else return {}
    }
  },
  watch: {
    disabled(val){
      //console.log('disabled change...:'+val)
    }
  },
  mounted() {
    this.$emit('mounted', this.field.name, this)
    if (this.field.type === 'textarea' && this.disabled) {
        setTimeout(() => {
          this.resizeTextArea()
        }, 500)
    }
  }
}
</script>

<style lang="scss">
.file-placeholder {
  @apply z-500 pt-20 pointer-events-none absolute left-0 right-0 text-center
}

[data-type='file']:hover .file-placeholder {
  color: #8BB2DB;
}
</style>
